import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { IPaginationResultFrequencies } from 'app/common/interfaces';
import { BusinessPartnerService } from 'app/modules/components/business-partners/business-partner/business-partner.service';
import { CalendarPeriodicityComponent } from './calendar-periodicity/calendar-periodicity.component';
import { MatMenuModule } from '@angular/material/menu';
import { SubRouteFrequenciesService } from '../sub-routes-frequency/sub-route-frequency.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import { MatSelectModule } from '@angular/material/select';
import { ModalFrecuencyComponent } from './modal-frecuency/modal-frecuency.component';
import { BusinessPartnerSubRoutesModalComponent } from './business-partner-sub-routes/business-partner-sub-routes.component';
import { SubRouteFrequenciesBPService } from '../sub-routes-frequency/sub-route-frequencies-bp.service';
import { DeleteConfirmationComponent } from 'app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component';
import { ModalAppointmentComponent } from './modal-appointment/modal-appointment.component';
import { getCode } from 'app/utils/method';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ModalMapComponent } from 'app/modules/components/shared/modal-map/modal-map.component';
import { ClienteInfoPopupComponent } from 'app/modules/components/shared/cliente-info-popup/cliente-info-popup.component';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { SubRoutePeriodicityExport } from './exports/sub-route-periodicity.export';
import { SUB_ROUTE_PERIODICITY_EXPORT_ID, SUB_ROUTE_PERIODICITY_NO_EXPORT_ID, SUB_ROUTE_PERIODICITY_NO_TITLE, SUB_ROUTE_PERIODICITY_TITLE } from './exports/sub-route-periodicity.constants';
import { CustomDatesModalComponent } from './modal-w-frequencies/modal-w-frequencies.component';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BusinessPartnerBySubRoute } from '../interfaces/busines-partner-by-sub-route.interface';
import { BusinessPartnerAddressService } from 'app/modules/components/business-partners/business-partner/business-partner-address-modal/business-partner-address.component.service';
import { BusinesPartnerGeoDialogComponent } from 'app/modules/components/business-partners/busines-partner-geo-dialog/busines-partner-geo-dialog.component';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { IUpdateBusinessPartner } from 'app/modules/components/business-partners/business-partner/interfaces/update-business-partner.interface';
import { take } from 'rxjs';
import { SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { MapModalComponent } from 'app/shared/components/map-modal/map-modal.component';
import { MapModalInputData } from 'app/shared/components/map-modal/models/map-modal.interface';
import { MapModalTypeEnum, MonitorDocumentTypeEnum } from 'app/shared/components/map-modal/models/map-modal.enum';
import { MatTooltipModule } from '@angular/material/tooltip';

export type SubRoutePeriodicityModalData = SubRouteAttributes;

@Component({
  selector: 'app-sub-route-periodicity',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSelectModule,
    ModalFrecuencyComponent,
    ModalAppointmentComponent,
    ClienteInfoPopupComponent,
    MatSlideToggleModule,
    MatTooltipModule
  ],
  providers: [SubRoutePeriodicityExport],
  templateUrl: './sub-route-periodicity.component.html',
  styleUrl: './sub-route-periodicity.component.scss'
})
export class SubRoutePeriodicityComponent {

  getCode = getCode
  dataSourceAssigned = new MatTableDataSource<BusinessPartnerBySubRoute>([]);
  displayedColumns: string[] = [
    "name",
    "principalContact",
    "principalAddress",
    "geolocationPoint",
    "frecuency",
    "status"
  ];

  dataSourceUnassigned = new MatTableDataSource<BusinessPartnerBySubRoute>([]);
  displayedColumnsUnassigned: string[] = [
    "det",
    "name",
    "principalContact",
    "principalAddress",
    "frecuency"
  ];
  selectionUnassigned = new SelectionModel<any>(true, []);

  //
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1
  sortActive: keyof BusinessPartnerAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  //
  totalItemsUnassigned = 0
  searchUnassigned: string = ''
  pageSizeUnassigned = 50
  pageIndexUnassigned = 1
  sortActiveUnassigned: keyof BusinessPartnerAttributes = "name";
  sortDirectionUnassigned: "ASC" | "DESC" = "ASC"

  isGlobalCalendarAvailable: boolean = false;
  
  //filter
  daysList: { code: number; day: string }[] = [
    {code: 1, day: "LU"},
    {code: 2, day: "MA"},
    {code: 3, day: "MI"},
    {code: 4, day: "JU"},
    {code: 5, day: "VI"},
    {code: 6, day: "SA"},
    {code: 7, day: "DO"}
  ];
  selectedFilterDays: number[] = []

  listFrecuencies: FrequenciesAttributes[]= []
  selectedFrecuency = null
  

  @ViewChild("byDayModal") byDayModal!: TemplateRef<any>;
  @ViewChild("frecuencyModal") frecuencyModal!: TemplateRef<any>;

  selectIndex:number = 0

  selectedClient: any = null;
  popupPosition = { top: '0px', left: '0px' };
  hideTimeout: any = null;

  //map
  isNew: boolean = true;

  constructor(
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly frequencyService: SubRouteFrequenciesService,
    private readonly subRouteFrequenciesBPService: SubRouteFrequenciesBPService,
    private readonly appointmentBPService :SubRouteFrequenciesService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<SubRoutePeriodicityComponent>,
    private subRoutePeriodicityExport: SubRoutePeriodicityExport,
    @Inject(MAT_DIALOG_DATA) public data: SubRoutePeriodicityModalData,
    private readonly businesPartnerAddressService: BusinessPartnerAddressService,
    private fuseConfirmationService: FuseConfirmationService
  ) {
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getAllBusinessPartnerAssigned()
    this.getAllBusinessPartnerUnAssigned()
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.search = input.value.trim();
    if(this.search.length > 2 || this.search.length == 0){
      this.pageIndex = 1
      this.getAllBusinessPartnerAssigned(); //Preguntar como se hizo la pregunta
    }    
  }

  getAllBusinessPartnerAssigned(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.businessPartnerService.findAllWithCountBySubRoute(options,this.data._id.toString(),true).subscribe({
      next: (res) => {
       
        const clientList = res?.data.data;
        const clientsData = clientList.filter(item => {
          //@ts-ignore
          (item ).bpDayFrecuenciesLength = item.frequenciesFromThisSubRoute.filter(f => f.type == 'W').length;
          //@ts-ignore
          (item as any).bpCustomFrecuenciesLength = item.frequenciesFromThisSubRoute.filter(f => f.type == 'C').length;
          
          //@ts-ignore
          let fuseDays = [... new Set(item.frequenciesFromThisSubRoute.flatMap(i => i.days))].sort((a:any, b:any) => a - b); 
          //@ts-ignore
          (item as any).bpDaysInAllFrecuencies = fuseDays.map(num => this.daysList.find(day => day.code === num)?.day || '')
            .filter(day => day)
            .join(', ');
          return item;
        })
        //@ts-ignore
        this.dataSourceAssigned.data = clientsData.filter((client) => client.frequenciesFromThisSubRoute.length > 0);
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err?.error?.message || "Error al traer registro", "Cerrar", {duration: 5000,verticalPosition: "top",});
      }
    });
  }

  onSearchChangeUnAssigned(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchUnassigned = input.value.trim();
    if(this.searchUnassigned.length > 2 || this.searchUnassigned.length == 0){
      this.pageIndexUnassigned = 1
      this.getAllBusinessPartnerUnAssigned();
    }    
  }

  getAllBusinessPartnerUnAssigned(): void {
    let options = { currentPage: this.pageIndexUnassigned, limitPerPage: this.pageSizeUnassigned, search: this.searchUnassigned, sort: this.sortActiveUnassigned, sortDirection: this.sortDirectionUnassigned }

    this.businessPartnerService.findAllWithCountBySubRoute(options,this.data._id.toString(),false).subscribe({
      next: (res) => {
      
        const clientList = res?.data.data;
        this.dataSourceUnassigned.data = clientList; //.filter((client) => client.frequenciesFromThisSubRoute.length === 0);
        this.totalItemsUnassigned = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err?.error?.message || "Error al traer registro", "Cerrar", {duration: 5000,verticalPosition: "top",});
      }
    });
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getAllBusinessPartnerAssigned()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getAllBusinessPartnerAssigned()
  }

  //Unassigned
  changeSortUnassigned(e) {
    this.sortActiveUnassigned = e.active
    this.sortDirectionUnassigned = e.direction?.toUpperCase() || "ASC"
    this.getAllBusinessPartnerUnAssigned()
  }

  changePageUnassigned(e: PageEvent) {
    this.pageIndexUnassigned = (e.pageIndex + 1)
    this.pageSizeUnassigned = e.pageSize
    this.getAllBusinessPartnerUnAssigned()
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectIndex = event.index;
  }
  
  //ASIGNAR
  onDeleteAssigned(element){
    this.dialog
    .open(DeleteConfirmationComponent, {
      data: {
        message: `¿Estás seguro de eliminar al cliente de la ruta?`,
        //name: item,
      },
      panelClass: "delete-modal",
      disableClose:true
    })
    .afterClosed()
    .subscribe((result) => result && this.onDeleteBpFromSubRoute(element));
  }

  async onDeleteBpFromSubRoute(element){
    const typeWIds = element.frequenciesFromThisSubRoute.filter(item => item.type === 'W').map(item => item._id);
    const typeCIds = element.frequenciesFromThisSubRoute.filter(item => item.type === 'C').map(item => item._id);

    if(typeWIds.length == 0 && typeCIds.length == 0){
      this.snackBar.open("El usuario no tiene registros para eliminar", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      return;
    }

    const deleteTypeWPromises = typeWIds.map(fbp =>
      this.subRouteFrequenciesBPService.deleteBusinessPartnerFromFrecuency(
        this.data._id.toString(),
        fbp,
        element._id
      )
      .toPromise()
    );

    let deleteTypeCPromise = null;
    if(typeCIds.length > 0){
      deleteTypeCPromise = this.appointmentBPService.deleteManyCompleteBusinessPartnerAppointment(
        this.data._id.toString(),
        element._id
      ).toPromise()
    }

    Promise.all([...deleteTypeWPromises, deleteTypeCPromise])
      .then(() => {
        this.snackBar.open("Registros eliminados correctamente", "Cerrar", {duration: 5000, verticalPosition: "top"});
        this.getAllBusinessPartnerAssigned();
      })
      .catch((error) => {
        this.snackBar.open(error?.error?.message || "Registro actualizado con éxito", "Cerrar", {duration: 5000, verticalPosition: "top"})
      });
  }

  //SIN ASIGNAR
  isAllSelected() {
    const numSelected = this.selectionUnassigned.selected.length;
    const numRows = this.dataSourceUnassigned.data.length;
    //return numSelected === numRows;
    return numSelected >= 1
  }

  masterToggle() {
    this.isAllSelected() ? this.selectionUnassigned.clear() : this.dataSourceUnassigned.data.forEach(row => {
      this.selectionUnassigned.select(row)
    });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionUnassigned.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void{
    this.isGlobalCalendarAvailable = this.selectionUnassigned.selected.length > 1; 
  }

  //calendar
  openModalCalendar(businessPartner: BusinessPartnerAttributes): void{

    let dataToSend = {
      subRouteId: this.data._id,
      businessPartners: [],
      frecuencySelected: null,
    }

    if(businessPartner){
      dataToSend.businessPartners.push(businessPartner);
    } else {
      dataToSend.businessPartners = this.selectionUnassigned.selected //this.dataSourceUnassigned.data.filter(e => e.isChecked);
    }

    const dialogRef = this.dialog.open(CalendarPeriodicityComponent, {
      //panelClass: ".form-modal-interlocutor",
      data: dataToSend,
      disableClose: true
      //width: '800px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(this.selectionUnassigned.selected.length > 0) this.selectionUnassigned.clear()
        this.isGlobalCalendarAvailable = false
        this.getAllBusinessPartnerAssigned();
        this.getAllBusinessPartnerUnAssigned();
      }
    });
  }

  openSubRoutesModal(element:any): void{
    const dialogRef = this.dialog.open(BusinessPartnerSubRoutesModalComponent, {
      //panelClass: ".form-modal-interlocutor",
      data: {
        businessPartner: element,
        subRoutes: element.subRoutes && element.subRoutes.length > 0 ? element.subRoutes : [],
        subRouteId: element._id
      },
      width: '450px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllBusinessPartnerAssigned();
      }
    });
  }
  
  //filter
  filterFrecuency(type){
    this.selectedFilterDays = []
    this.selectedFrecuency = null

    if(type == 'D'){
      this.openFilterDayModal()      
    }else{
      this.getListFrecuencies()
      this.openFilterFrecuencyModal()
    }
  }

  openFilterDayModal(): void {
    this.dialog.open(this.byDayModal)
      .afterClosed()
      .subscribe((result) => result && this.filterSelectModal('D'));
  }

  openFilterFrecuencyModal(): void {
    this.dialog.open(this.frecuencyModal)
      .afterClosed()
      .subscribe((result) => result && this.filterSelectModal('F'));
  }

  filterSelectModal(type){
  }

  onDayFilterSelectionChange(day: { code: number; selected?: boolean }): void {
    if (day.selected) {
      if (!this.selectedFilterDays.includes(day.code)) {
        this.selectedFilterDays.push(day.code); // Agrega el código del día seleccionado
      }
    } else {
      this.selectedFilterDays = this.selectedFilterDays.filter((code) => code !== day.code); // Elimina el código del día deseleccionado
    }
  }

  getNameDay(abbreviation: string): string {
    const dayNames: { [key: string]: string } = {
      LU: 'LUNES',
      MA: 'MARTES',
      MI: 'MIÉRCOLES',
      JU: 'JUEVES',
      VI: 'VIERNES',
      SA: 'SÁBADO',
      DO: 'DOMINGO'
    };
    return dayNames[abbreviation] || '';
  }

  getListFrecuencies(){
    this.frequencyService.findBySubRouteId(this.data._id.toString()).subscribe({
      next: (res) => {
        this.listFrecuencies = res?.data
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener las frecuencias","Cerrar",{ duration: 5000});
      },
    });
  }

  getFrecuencyName(days: number[]): string {
    const dayNames = days.map((code) => this.daysList.find((day) => day.code === code)?.day).filter(Boolean);
    return dayNames.join('-');
  }

  openModal(element): void {
    if (!element?.principalAddress?.geolocationPoint || element.principalAddress.geolocationPoint.length == 0) return;

    if(this.isNew){
      const data: MapModalInputData = {
        type: MapModalTypeEnum.SIMPLE,
        tripId: null,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: 'drawer',
          captions: { title: 'Ubicación' }
        }
      }

      this.openMap(data)
    }else{
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: element.principalAddress,
        disableClose: true,
      });
    }
  }

  openModalFrecuency(type: string): void {
    const data: MapModalInputData = {
      type: MapModalTypeEnum.FRECUENCY_ROUTE,
      tripId: null,
      element: {
        ...this.data,
        type: type
      },
      document: MonitorDocumentTypeEnum.NONE,
      groupDocuments: [],
      map: {
        displayMode: 'drawer',
        captions: { title: this.data?.name || 'Frecuencia'}
      }
    }

    this.openMap(data)
  }

  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }

  showPopup(cliente: any, event: MouseEvent) {
    this.selectedClient = cliente;
    this.popupPosition = {
      top: `${event.clientY + 10}px`,
      left: `${event.clientX + 10}px`
    };
  }
  
  hidePopupWithDelay() {
    this.hideTimeout = setTimeout(() => {
      this.selectedClient = null;
    }, 300);
  }
  
  cancelHidePopup() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  //exportar idSubRoutePeriodicity?: string, type?: boolean
  onExportButtonPressed(type) {
    const typePeriodicityTitle = type ? SUB_ROUTE_PERIODICITY_TITLE : SUB_ROUTE_PERIODICITY_NO_TITLE
    const typePeriodicityId = type ? SUB_ROUTE_PERIODICITY_EXPORT_ID : SUB_ROUTE_PERIODICITY_NO_EXPORT_ID
    
    if (!this.subRoutePeriodicityExport.canStartTask(typePeriodicityId)) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: typePeriodicityTitle},
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.subRoutePeriodicityExport.export(
          typePeriodicityId,
          typePeriodicityTitle,
          options.format,
          options.range,
          type ? this.totalItems : this.totalItemsUnassigned,
          type ? this.pageSize : this.pageSizeUnassigned,
          type ? this.pageIndex : this.pageIndexUnassigned,
          this.data._id.toString(),
          type,
        );
      }
    });
  }

  openCustomFrequenciesModal(element: any) {
    const dialogRef = this.dialog.open(CustomDatesModalComponent, {
      data: {
        frequencies: element,
        subRoute: this.data
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

 // Método principal para manejar el cambio del toggle de geolocalización
onUpdateGeo(event: MatSlideToggleChange, businessPartnerBySubRoute: BusinessPartnerBySubRoute) {

  const originalCheckedEvent = event.checked;
  event.source.checked = !event.checked;

  this.fuseConfirmationService.open({
    title: 'Confirmación',
    message: originalCheckedEvent 
      ? `¿Estás seguro de que deseas repinear la geolocalización de ${businessPartnerBySubRoute?.principalAddress?.address}?` 
      : `¿Estás seguro de que deseas quitar la solicitud de repineo a la geolocalización de ${businessPartnerBySubRoute?.principalAddress?.address}?`,
    actions: {
      confirm: {
        label: 'Sí',
      },
      cancel: {
        label: 'No',
      }
    }
  }).afterClosed().subscribe((result) => {
    if (result === 'confirmed') {
      this.performGeoUpdate(businessPartnerBySubRoute, originalCheckedEvent);
      event.source.checked = originalCheckedEvent;
      setTimeout(() => {
        businessPartnerBySubRoute.principalAddress.geolocationPointUpdate = originalCheckedEvent;
      }, 0);
    } else {
      event.source.checked = !originalCheckedEvent;
      setTimeout(() => {
        businessPartnerBySubRoute.principalAddress.geolocationPointUpdate = !originalCheckedEvent;
      }, 0);
    }
  });
}

// Método para realizar la actualización de geolocalización
private performGeoUpdate(businessPartnerBySubRoute: BusinessPartnerBySubRoute, geolocationPointUpdate: boolean): void {

  // Actualizar el estado de geolocalización en la dirección
  this.updateGeoPointUpdateFromService({
    businessPartnerId: businessPartnerBySubRoute._id.toString(),
    geolocationPointUpdate: geolocationPointUpdate,
    addressId: businessPartnerBySubRoute.principalAddress._id
  })
  .pipe(take(1))
  .subscribe({
    next: () => {
      // If geolocationPointUpdate is true and subRoute is available, update the business partner's geo status
      if (geolocationPointUpdate && this.data) {
        this.updateBusinessPartnerGeoStatus(businessPartnerBySubRoute, this.data);
      } else if (!geolocationPointUpdate) {
        // If geolocationPointUpdate is false, update the business partner's address geo status
        this.updateBusinessPartnerAddressGeoStatus(businessPartnerBySubRoute, geolocationPointUpdate);
      }
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al actualizar la geolocalización", "Cerrar", { duration: 5000 });
    },
  });

}

// Método para actualizar el estado de geolocalización en la dirección
updateGeoPointUpdateFromService(payload: {businessPartnerId: string, geolocationPointUpdate: boolean; addressId: string}) {
  const observable = this.businesPartnerAddressService.updateEmbedded(payload.businessPartnerId, payload.addressId, {
    geolocationPointUpdate: payload.geolocationPointUpdate
  });

  observable.subscribe({
    next: (res) => {
      this.getAllBusinessPartnerAssigned();
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al actualizar la geolocalización", "Cerrar", { duration: 5000 });
    },
  });

  return observable;
}

// Method to update the business partner with route information (when repining is activated)
private updateBusinessPartnerGeoStatus(businessPartnerBySubRoute: BusinessPartnerBySubRoute, selectedSubRoute: any): void {
  const updatedBusinessPartner: IUpdateBusinessPartner = {
    subRouteGeoUpdatePending: [
      {
        ...selectedSubRoute,
        date: new Date().toISOString(),
      }
    ],
  };

  this.businessPartnerService.updateGeo(
    businessPartnerBySubRoute._id.toString(),
    businessPartnerBySubRoute.principalAddress._id.toString(),
    updatedBusinessPartner
  ).subscribe({
    next: () => {
      this.snackBar.open("Registro actualizado con éxito", "Cerrar", { duration: 3000 });
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al actualizar el registro", "Cerrar", { duration: 3000 });
    },
    complete: () => {
    }
  });
}

// Method to update only the geolocation status (when repining is deactivated)
private updateBusinessPartnerAddressGeoStatus(businessPartnerBySubRoute: BusinessPartnerBySubRoute, geolocationPointUpdate: boolean): void {
  const updatedBusinessPartner: any = {
    geolocationPointUpdate: geolocationPointUpdate,
  };

  // TODO: correct typing of businesspartner by subroute info to get external code typing
  //@ts-ignore
  const externalCode = businessPartnerBySubRoute.externalKeys?.code || businessPartnerBySubRoute.id.toString();

  this.businessPartnerService.updateAddressGeoStatus(
    externalCode,
    businessPartnerBySubRoute.principalAddress._id.toString(),
    updatedBusinessPartner
  ).subscribe({
    next: () => {
      this.snackBar.open("Registro actualizado con éxito", "Cerrar", { duration: 3000 });
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al actualizar el registro", "Cerrar", { duration: 3000 });
    },
    complete: () => {
    }
  });
}

// Method to verify if the main address has valid geolocation points
customerPrincipalAddressHasGeoPoints(customerBySubRoute: BusinessPartnerBySubRoute): boolean {
  const customerPrincipalAddressGeoPoints = customerBySubRoute?.principalAddress?.geolocationPoint ?? [];
  
  return customerPrincipalAddressGeoPoints.length > 0 && customerPrincipalAddressGeoPoints.some((g) => g != 0);
}

}
